import i18next from 'i18next'
import { Validator } from 'vee-validate'
import locale2 from 'locale2'
import subtag from 'subtag'

const detectedLanguage = subtag.language(locale2 || 'de')

const state = {
  currentLanguage: detectedLanguage
}

const getters = {
  languages: (state, getters, rootState) => {
    const { features } = rootState.config

    const languages = {
      en: 'English',
      da: 'Dansk',
      de: 'Deutsch',
      nl: 'Dutch',
      nl_be: 'Dutch (BE)',
      fr: 'Français',
      fr_be: 'Français (BE)',
      pl: 'Polski',
      hu: 'Magyar',
      es: 'Español',
      cs: 'Čeština',
      sl: 'Slovenščina',
      sk: 'Slovenský',
      fi: 'Suomi',
      pt: 'Português',
      it: 'Italiano',
      hr: 'Hrvatski',
      sv: 'Svenska',
      et: 'Eesti Keel',
      lt: 'Lietuviškai',
      lv: 'Latviski'
    }

    if (features['dev-lang-enabled']) {
      languages['cimode'] = 'DEV'
    }

    return sortJSONByValue(languages)
  }
}

const actions = {
  languageSelect({ commit }, lang) {
    commit('SET_LANGUAGE', lang)
    i18next.changeLanguage(lang)
    Validator.localize(lang)
  },
}

const mutations = {
  SET_LANG_CONFIG(state, langConfig) {
    state.langConfig = langConfig
  },

  SET_LANGUAGE(state, lang) {
    state.currentLanguage = lang
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

function sortJSONByValue(jsObj) {
  var array = []
  var sortedObj = {}
  // convert json obj to array with json value first
  for (var el in jsObj) {
    array.push([jsObj[el], el])
  }
  var sortedArray = array.sort()
  // reconstruct json obj from sorted array
  for (var i in sortedArray) {
    sortedObj[sortedArray[i][1]] = sortedArray[i][0]
  }
  return sortedObj
}



// WEBPACK FOOTER //
// ./client/store/modules/lang/index.js